<template>
  <VideoAccessPage
    video-title="ACSP ID&V Training Video"
    video-description="Comprehensive training video covering ID verification procedures and compliance requirements for ACSPs."
    vimeo-video-id="1145888855"
    video-type="acsp-training"
  />
</template>

<script>
import VideoAccessPage from './VideoAccessPage.vue';

export default {
  name: 'AcspTrainingVideo',
  components: {
    VideoAccessPage,
  },
};
</script>
